import React from 'react';
import Head from './Head';
import About from './About';
import Intro from './Intro';
import Skill from './Skill';
import Projects from './Projects';
import Research from './Research';
import Contact from './Contact';
import Footer from './Footer';
import './css/home.css';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
export default function Home() {
  return (
    <div>
      {/* <div className="home-head">
        <Head />
      </div> */}

      <div className="content">
        <Head />
        <Intro />
        <About />
        <Skill />
        <Projects />
        <Research />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}
